import { useState, useRef } from 'react';
import Util from 'lib/util.js';
import Storage from 'services/storage2';
import Http from 'services/http2';
import User from 'services/user2';
import EnumService from 'services/enum2';
import CompanyService from 'services/company2';
import WorkflowService from 'services/workflow2';
import CustFieldService from 'services/custField';
import { BillType } from 'constants/custom-types';

// 附件上传下载默认配置
const DefaultFileConfigItem = {
  xkNoField: '',
  companyCodeField: 'companyCode',
  fileListField: 'fileList',
  fileMd5sField: 'fileMd5s',
  queueLimit: 5,
  maxFileSize: 5,
  totalMaxFileSize: 5
};

/**
 * 详情页自定义Hooks
 *
 * @param props
 * @param config
 * @returns
 */
export default function useDetail(props: any, config: any) {
  const [companyCode, setCompanyCode] = useState<string | null>(null);
  const [inited, setInited] = useState(false); //初始化顶部菜单/搜索栏
  const [error, setError] = useState<any>(null); //页面加载时错误
  const [dataError, setDataError] = useState<any>(null);
  const [errorMsg, setErrorMsg] = useState<any>(null);
  const [detail, setDetail] = useState({});
  const [workflow, setWorkflow] = useState<any>({ wfmCode: config.wfmCode });
  const [redirect, setRedirect] = useState(null);
  const [moreSign1, setMoreSign1] = useState(true);
  const [moreSign2, setMoreSign2] = useState(true);
  const [decimalPlace, setDecimalPlace] = useState({});
  const [fileList, setFileList] = useState([]);
  const [showLoading, setShowLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [updateTs, setUpdateTs] = useState(0);
  const [fileConfig, setFileConfig] = useState(0);
  const [isOpenOrgFlag, setIsOpenOrgFlag] = useState(false); // 是否有开启采购组织状态

  let objHistoryState: any = Storage.getItem('historyState') || {};
  let urlHashKey: string = Util.getHashKey(props.match.url);
  let historyState: any = { searchKey: '' };
  let isPurchase = props.type.indexOf('purchase') !== -1;
  let companyInfo = {};
  let searchQueries = {}; //列表请求参数
  let idField: string = config.idField; //单据id字段名
  let detailParams = config.detailParams || {}; //详情接口参数
  let pageResolveLoading: Function = () => {}; //引用InfiniteLoader中resolveLoading方法，用于重置列表加载状态
  let init: Function = () => {};
  let getCount: Function = () => {};
  let getDetail: Function = () => {};
  let afterGetDetail: Function = () => {};
  let initWorkflow: Function = () => {};
  let errorTimer;
  let toastTimer;
  let id = props.match.params.id;

  /** 自定义字段 begin */
  let dispatch = config.dispatch;
  let custFieldBillType: BillType = config.custFieldBillType; //自定义字段单别
  let lineListField: string = 'lineList'; //单身字段
  const [fieldSetting, setFieldSetting] = useState({
    headCustList: [],
    bodyCustList: []
  }); //自定义字段设置
  const [isEditField, setIsEditField] = useState(false); //采购方是否显示编辑按钮

  /**
   *  获取自定义字段设置
   *
   * @param currCustomerCode 供应商端必填
   * @param billType 如果需要单独获取某种单别自定义字段，请传此参数
   *
   * @returns fieldSetting
   */
  async function getFieldSetting(currCustomerCode?, billType?) {
    custFieldBillType = billType || config.custFieldBillType;

    if (custFieldBillType) {
      let supplierCategoryInfo; // 供应商分类信息
      // if (['22', '51'].includes(custFieldBillType)) {
      //   supplierCategoryInfo = await this.company.getSupplierCategory(
      //     this.companyCode,
      //     this.isPurchase ? this.detail.vendorXkUniqueCode : this.detail.customerXkUniqueCode,
      //     this.isPurchase
      //   );
      // }
      await CustFieldService.getSetting(
        companyCode,
        currCustomerCode,
        true,
        custFieldBillType,
        dispatch,
        supplierCategoryInfo
      ).then(async setting => {
        if (setting) {
          //采购方是否显示编辑按钮
          if (isPurchase && !billType) {
            setIsEditField(
              (setting.headCustList?.length > 0 &&
                setting.headCustList?.some(item => item.editFlag === 1)) ||
                (setting.bodyCustList?.length > 0 &&
                  setting.bodyCustList?.some(item => item.editFlag === 1))
            );
          }

          //上游单据字段转换
          await CustFieldService.transformSourceField(
            companyCode,
            currCustomerCode,
            setting
          );

          let copyDetail = Object.assign({}, self.detail);
          let lineList = copyDetail[lineListField];
          // 单头单身日期字段，转换为时间戳
          CustFieldService.parseCustFields(
            setting,
            copyDetail,
            lineList,
            isPurchase
          );
          copyDetail[lineListField] = lineList;
          setDetail(copyDetail);
          setFieldSetting(setting);
        }
      });
    }
  }

  //自定义预设值改变
  // presetValueChange(event, item, line) {
  //   line[item.fieldCode] = event.id ? event.id : undefined;
  // }

  /** 自定义字段 end */

  /**
   * 上传附件
   *
   * @param oft
   * @param item 单头附件传 detail, 单身附件传 item
   */
  function uploadFile(oft, item) {
    fileConfig[oft] = Object.assign({}, DefaultFileConfigItem, fileConfig[oft]);
    let {
      companyCodeField,
      getBusinessKey,
      xkNoField,
      lineNoField,
      fileListField,
      fileMd5sField,
      canDel,
      uploadAuthCode,
      queueLimit,
      maxFileSize,
      totalMaxFileSize,
      maxImageResolution,
      modalId,
      uploadInfo
    } = fileConfig[oft];

    // 弹窗
    let popUp = () => {
      if (
        !uploadAuthCode ||
        (uploadAuthCode && User.checkAuth(uploadAuthCode))
      ) {
        dispatch({
          type: 'showUpload',
          config: {
            oft,
            modalId,
            uploadInfo,
            queueLimit,
            canDel,
            maxFileSize,
            totalMaxFileSize,
            maxImageResolution,
            initData: item[fileListField],
            orgCompanyCode: detail[companyCodeField] || companyCode
          }
        });
        // let dialogRef = this.dialog.open(DialogUploadComponent, {
        //   width: '1000px',
        //   autoFocus: false,
        //   data: {
        //     oft,
        //     modalId,
        //     uploadInfo,
        //     queueLimit,
        //     canDel,
        //     maxFileSize,
        //     totalMaxFileSize,
        //     maxImageResolution,
        //     initData: item[fileListField],
        //     orgCompanyCode: detail[companyCodeField] || companyCode
        //   }
        // });
        // 在页面实现
        // dialogRef.afterClosed().subscribe(event => {
        //   if (event) {
        //     item[fileMd5sField] = event
        //       .filter(row => row.fileMd5)
        //       .map(row => row.fileMd5);
        //     item[fileListField] = event;
        //     if (typeof this.saveFile === 'function') {
        //       this.saveFile(oft, item);
        //     }
        //   }
        // });
      }
    };

    let businessKey = lineNoField
      ? detail[xkNoField] + '_' + item[lineNoField]
      : detail[xkNoField];

    if (typeof getBusinessKey === 'function') {
      businessKey = getBusinessKey(item);
    }

    let lineNo = lineNoField ? item[lineNoField] : '0';
    let xkNo = detail[xkNoField];
    let fileCompanyCode = detail[companyCodeField];

    if (item[fileListField]?.length > 0) {
      popUp();
    } else {
      // 获取附件列表
      CompanyService.getFileList(
        oft,
        businessKey,
        xkNo,
        lineNo,
        fileCompanyCode
      ).then(list => {
        if (list && list.length > 0) {
          item[fileListField] = list;
          item[fileMd5sField] = list.map(file => file.fileMd5);
        } else {
          item[fileListField] = [];
        }
        popUp();
      });
    }
  }

  //创建实例，用于储存非状态可变值
  let instant = useRef({
    id,
    isPurchase,
    companyInfo,
    objHistoryState,
    urlHashKey,
    historyState,
    pageResolveLoading,
    init,
    getCount,
    getDetail,
    detail,
    searchQueries,
    detailParams,
    afterGetDetail,
    errorTimer,
    toastTimer,
    initWorkflow
  });
  let self = instant.current;

  self.init = function (routeCompanyCode: string) {
    User.init(routeCompanyCode).then(response => {
      if (response.success) {
        setInited(true);
        setCompanyCode(routeCompanyCode || '');
        let objCompanyInfo = User.getCompanyInfo(companyCode) || {};
        self.companyInfo = objCompanyInfo;
        setIsOpenOrgFlag(objCompanyInfo.openOrgFlag === 1);
      } else {
        setError({
          type: 'warn',
          title: response.errorMsg
        });
      }
    });
  };

  self.getCount = function () {
    if (!companyCode) {
      return;
    }
    let postbody = {
      apiPath: config.countApi,
      companyCode
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        config.countTransform(response.data);
      }
    });
  };

  self.getDetail = async function () {
    if (!companyCode) {
      return;
    }
    let postbody: any = {
      apiPath: config.apiPath,
      companyCode: companyCode,
      ...detailParams
    };
    postbody[idField] = id;
    await Http.post('/api/cloudCenter', postbody).then(async response => {
      if (response.success) {
        let data = { ...response.data };

        //枚举转换
        if (config?.arrEnumField?.length > 0) {
          for (let conf of config.arrEnumField) {
            await EnumService.getValue(conf.mainKey, data[conf.subKey]).then(
              value => {
                data[conf.value] = value;
              }
            );
          }
        }

        //小数位获取
        let compCode = isPurchase ? companyCode : data.customerCode;
        CompanyService.getDecimalPlaceByCodes(compCode).then((rs: any) => {
          let obj: any = {};
          for (let code in rs) {
            obj[code] = rs[code];
          }
          setDecimalPlace(obj);
        });

        self.afterGetDetail(data);
        self.detail = data;
        setDetail(data);

        getFieldSetting(data.customerCode);

        //初始化审批流
        self.initWorkflow(data);
      } else {
        setError({
          type: 'warn',
          title: response.errorMsg
        });
      }
    });
  };

  //初始化审批流（获取单据详情后调用）
  self.initWorkflow = (data: any) => {
    //流程配置
    if (workflow.wfmCode && typeof companyCode === 'string') {
      WorkflowService.init(companyCode, workflow, id, self.isPurchase).then(
        res => {
          if (workflow.isActive) {
            WorkflowService.getStatus(companyCode, [data], workflow, true).then(
              rs => {
                setWorkflow(workflow);
                forceUpdate();
              }
            );
          } else {
            setWorkflow(workflow);
          }
        }
      );
    }
  };

  //强制重新渲染
  function forceUpdate() {
    setUpdateTs(Date.now());
  }

  function handleMore(idx: number) {
    if (idx === 1) {
      setMoreSign1(!moreSign1);
    } else if (idx === 2) {
      setMoreSign2(!moreSign2);
    }
  }

  //搜索关键字改变
  function handleChange(text: string, e: any) {
    e.preventDefault();
    handleReset();
  }

  //重置列表
  function handleReset() {
    setShowLoading(false);
    self.pageResolveLoading();
  }

  return {
    companyCode,
    setCompanyCode,
    inited,
    detail,
    setDetail,
    workflow,
    setInited,
    error,
    setError,
    dataError,
    setDataError,
    errorMsg,
    setErrorMsg,
    redirect,
    setRedirect,
    moreSign1,
    moreSign2,
    setMoreSign1,
    setMoreSign2,
    handleMore,
    decimalPlace,
    fileList,
    setFileList,
    showLoading,
    showError,
    setShowError,
    setShowLoading,
    forceUpdate,
    handleChange,
    handleReset,
    updateTs,
    setUpdateTs,
    setWorkflow,
    isEditField,
    fieldSetting,
    self,
    uploadFile,
    fileConfig,
    setFileConfig,
    isOpenOrgFlag
  };
}
